import { Component, Inject, OnInit } from '@angular/core';
import { Sort, SortDirection } from '@angular/material/sort';
import { Router } from '@angular/router';
import { Contact } from '../../../classes';
import { CONTACTS_PROVIDER_SERVICE, IContactsProviderService } from '../../../interfaces';

@Component({
  selector: 'app-contact-table',
  templateUrl: './contact-table.component.html',
  styleUrls: ['./contact-table.component.css']
})
export class ContactTableComponent implements OnInit {

  columns = [ 'contactperssalutation', 'contactpersfname', 'contactperslname', 'controls' ];
  footerColumns = [ 'contactperssalutation' ];

  active: string = 'contactperslname';
  direction: SortDirection = 'asc';

  constructor(
    @Inject(CONTACTS_PROVIDER_SERVICE) public providerService: IContactsProviderService,
    private _router: Router
  ) { }

  ngOnInit(): void {

  }

  showContact = (contact: Contact) => this._router.navigate(['/contact-details', contact.contactpersid]);

  sortData(sort: Sort){
    this.active = sort.active;
    this.direction = sort.direction;
  }

}
